import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '../../../../tooltip/tooltip';
import { InlineIcon } from '../../../../inline-icon/inline-icon';
import MoreIcon from '../../../../../icons/compiled/components/MoreIcon';
import styles from './styles.scss';
export class More extends React.Component {
    render() {
        const { className, onClick, dataHook, ariaLabel, tooltip } = this.props;
        return (React.createElement(Tooltip, { content: tooltip },
            React.createElement("button", { "data-hook": dataHook, onClick: onClick, className: `${className} ${styles.icon}`, "aria-label": ariaLabel },
                React.createElement(InlineIcon, { icon: React.createElement(MoreIcon, null) }))));
    }
}
More.propTypes = {
    className: PropTypes.string,
    tooltip: PropTypes.node,
    dataHook: PropTypes.string,
    onClick: PropTypes.func,
    ariaLabel: PropTypes.string,
};
//# sourceMappingURL=more.js.map